import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';
import { SavedPropertiesService } from 'src/app/services/saved-properties.service';
import { UtilsPropertiesService } from 'src/app/services/utils-properties.service';

@Component({
  selector: 'app-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.css']
})
export class GridViewComponent implements OnInit {

  @Input() properties!: any[];

  constructor(
    public savedService: SavedPropertiesService,
    public loadingService: LoadingService,
    public utilsPropertiesService: UtilsPropertiesService
  ) { }

  ngOnInit(): void { }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) => String(price)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return symbol + ' ' + spaces(propertyPrice);
  }

  getDistance(distance: number) {
    if (distance > 1000) {
      return (distance / 1000).toFixed(2) + 'km';
    } else {
      return distance + 'mts'
    }
  }

}
